
import { AppClientRemoveAllCartItems } from "Constants/api.constant";
import { AppClientRemoveAllCartItemsResponse } from "features/cart/interfaces/cart-api.interface";
import { CartSave } from "Types/CartSave";
import { ProductPackerDTO } from "Types/ProductPackerDTO";
import { ResultsDTO } from "Types/ResultsDTO";
import { ApiService } from "./ApiService";

export const CartApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllCartWithId: builder.query<ProductPackerDTO, { cartItems: Array<string> }>({
      query: ({ cartItems }) => ({
        url: `/products?page=1&productsCount=1&mode=item_group&items=${cartItems}`,
        method: "GET",
      }),
      transformResponse: (res: { results: ProductPackerDTO }) => res.results,
    }),
    getCustomerCart: builder.query<any[], void>({
      query: () => ({
        url: `/cart`,
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<any[]>) => res.results ?? [],
    }),
    updateCustomerCart: builder.mutation<ResultsDTO, Array<CartSave>>({
      query: (cartList) => ({
        url: "/cart",
        method: "POST",
        body: cartList,
      }),
    }),
    removeItemFromCart: builder.mutation<ResultsDTO, string>({
      query: (productId) => ({
        url: `/cart/${productId}`,
        method: "DELETE",
      }),
    }),
    removeAllFromCart: builder.mutation<ResultsDTO<AppClientRemoveAllCartItemsResponse>, void>({
      query: () => ({
        url: AppClientRemoveAllCartItems,
        method: "DELETE",
      }),
    }),
    updateItemQuantity: builder.mutation<ResultsDTO, { productId: string; mode: string; size: string }>({
      query: ({ productId, mode, size }) => ({
        url: `/cart?productId=${productId}&mode=${mode}&size=${size}`,
        method: "PUT",
      }),
    }),
    deleteCartItem: builder.mutation<ResultsDTO, { productid: string; size: string }>({
      query: ({ productid, size }) => ({
        url: `/cart/removeCartItem?productId=${productid}&size=${size}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetAllCartWithIdQuery,
  useLazyGetAllCartWithIdQuery,
  useGetCustomerCartQuery,
  useLazyGetCustomerCartQuery,
  useUpdateCustomerCartMutation,
  useRemoveItemFromCartMutation,
  useRemoveAllFromCartMutation,
  useUpdateItemQuantityMutation,
  useDeleteCartItemMutation,
} = CartApiSlice;
